import { ensureConfig } from "./configuration-service";

export const getMatterLink = (matterId: string | undefined) => {
  const regionConfig = ensureConfig();

  const appUrl = regionConfig.WebappUrl;

  return `${appUrl}#/billing/view-matter/${matterId ?? ""}/dashboard`;
};
